import { cn } from "@/lib/utils";

export type ChurchWorkspaceTab =
  | "overview"
  | "administrators"
  | "invitations"
  | "activity"
  | "operations";

const tabs: {
  id: ChurchWorkspaceTab;
  label: string;
}[] = [
  { id: "overview", label: "Overview" },
  { id: "administrators", label: "Administrators" },
  { id: "invitations", label: "Invitations" },
  { id: "activity", label: "Activity" },
  { id: "operations", label: "Operations" },
];

interface Props {
  value: ChurchWorkspaceTab;
  onChange(tab: ChurchWorkspaceTab): void;
}

export function ChurchWorkspaceTabs({
  value,
  onChange,
}: Props) {
  return (
    <div className="border-b border-slate-200">
      <nav className="flex gap-1 overflow-x-auto px-6">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            type="button"
            onClick={() => onChange(tab.id)}
            className={cn(
              "border-b-2 px-4 py-3 text-sm font-medium transition-colors",
              value === tab.id
                ? "border-indigo-600 text-indigo-600"
                : "border-transparent text-slate-500 hover:text-slate-900"
            )}
          >
            {tab.label}
          </button>
        ))}
      </nav>
    </div>
  );
}